export default __webpack_public_path__ + "static/media/feedback_oops_01.c2647474.png";